import React from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TITLE, ENGLISH, HINDI, HOME, HOW_IT_WORKS, TEAM, PARTNER, ABOUT, CONTACT } from '../data/navbar/menu';
import Container from 'react-bootstrap/Container';
import '../styles/AppBar.css';

import Logo from '../assets/images/logo.png';
// import English from '../assets/images/english.png';
// import Hindi from '../assets/images/hindi.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';

let menu = [
  {
    title: HOME,
    link: '#home'
  },
  {
    title: HOW_IT_WORKS,
    link: '#introduction'
  },
  {
    title: TEAM,
    link: '#team'
  },
  {
    title: PARTNER,
    link: '#partner'
  },
  {
    title: ABOUT,
    link: '#services'
  },
  {
    title: CONTACT,
    link: '#contact'
  },

]

const AppBar = (props) => {

  const { t, i18n } = useTranslation();

  const handleLangChange = (newlang) => {
    console.log(newlang);
      i18n.changeLanguage(newlang);
  }
  return (
    <Navbar collapseOnSelect expand="lg" variant="dark" fixed="top">
      <Container>
      <Navbar.Brand href="#home">
        <img
          class="logo"
          alt=""
          src={Logo}
          width="30"
          height="30"
          className="d-inline-block align-top"
        />
        {t(TITLE)}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
        <Nav>
          {menu.map(menuItem => (
            <Nav.Link key={menuItem.link} href={menuItem.link}>{t(menuItem.title)}</Nav.Link>
          ))}
          <NavDropdown title={<FontAwesomeIcon icon={faLanguage} size='lg'/>} id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => handleLangChange('hin')}>
              {/* <img
                class="logo"
                alt=""
                src={Hindi}
                width="16"
                height="16"
                style={{marginRight: '10px', verticalAlign: 'middle'}}
              /> */}
              {t(HINDI)}
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleLangChange('en')}>
              {/* <img
                class="logo"
                alt=""
                src={English}
                width="16"
                height="16"
                style={{marginRight: '10px', verticalAlign: 'middle'}}
              /> */}
              {t(ENGLISH)}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
      </Container>
    </Navbar>      
  );
}


export default AppBar;